import { useNavigate } from 'react-router-dom';
import { landingStyles } from '../landing.styles';
import { useIsMobile } from '../hooks/useIsMobile';

const logoAzul = require('../imagenes/kaiteki-logo-azul.jpg');

const BotonHeader = ({text, onClick}: {text: string, onClick: () => void}) => {
	return (
		<button 
			onClick={onClick}
			style={landingStyles.btnPrimary}
		>
			{text}
		</button>
	)
}

export const LandingHeader = () => {
	const navigate = useNavigate();
	const isMobile = useIsMobile();

	const scrollToSection = (id: string) => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return (
		<header style={landingStyles.header}>
			<div style={landingStyles.headerLogo}>
				<img src={logoAzul} alt="Kaiteki Logo" width="50" height="50" />
				<h1 style={landingStyles.headerTitle}>Kaiteki</h1>
			</div>
			<nav style={landingStyles.nav}>
				<BotonHeader text="Soy Paciente" onClick={() => {
					navigate('/app/login');
				}} />
				{!isMobile && <BotonHeader text="Soy Médico" onClick={() => {
					navigate('/med/login');
				}} />}
			</nav>
		</header>
	);
};

